module.exports = "/images/normalHome.png?65d215b35490ba3b8ac14b899a74bca7";